import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { scssVariables as variables, remCss, lang, withRouter } from 'src/helpers';

import Speciality from './Speciality';

import model from '../model';
import LANG_CONST from 'src/helpers/lang/const';

const style = {};

style.backgroundColor = variables['colors-mc-white'];

class SignupClinicPopup extends BaseComponent {
  state = {
    step: 0
  };

  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    let step = this.state.step;
    let steps = [Speciality];
    let titles = ['Speciality'];
    let Component = steps[step];
    const { closeBtn, hide } = this.props;
    return (
      <div className='mc-popup-contain mc-popup-signup-doctor' style={{ width: remCss(660) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t(titles[step])}</div>
          {closeBtn}
        </div>
        <div className='mc-modal-body' style={{ display: 'flex', flexDirection: 'column' }}>
          <Component
            showBtns={true}
            next={() => {
              if (step < steps.length - 1) {
                this.setState({ step: step + 1 });
              } else {
                hide();
              }
            }}
            prev={step > 0 ? () => this.setState({ step: step - 1 }) : null}
            labelNext={LANG_CONST.buttons.save}
            close={hide}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(SignupClinicPopup);
